import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/bg-video.mp4")